import axios from 'axios';

import env from '~/env';
import { injectAccessTokenInterceptor, refreshTokenResponseInterceptor }
  from '~/services/keycloack-api/keycloack-api.interceptors';

const http = axios.create({
  baseURL: env.VITE_CAPITAL_MARKETS_API_URL,
});

http.interceptors.request.use(injectAccessTokenInterceptor);
http.interceptors.response.use((_) => _, refreshTokenResponseInterceptor);

export default http;
